import { gql } from "@apollo/client";

export const HERO_DISPLAYS = gql`
    query HeroDisplays {
        heroDisplays {
            hero
            imgUrl
            thumbnailUrl
            portraitUrl
            fullPortraitUrl
            lightColor
            darkColor
        }
    }
`;

export const LATEST = gql`
    query Latest($platform: String, $mode: String, $rank: String, $role: String, $includeThirdParty: Boolean) {
        latest(platform: $platform, mode: $mode, rank: $rank, role: $role, includeThirdParty: $includeThirdParty) {
            dateUpdated
            dateScraped
            data {
                platform
                mode
                rank
                heroStats {
                    hero
                    role
                    pick
                    win
                    winUnmirrored
                    banRate
                }
            }
        }
    }
`;

export const HEROES_HISTORY = gql`
    query HeroesHistory(
        $heroes: [String!]!
        $platform: String
        $mode: String
        $rank: String
        $timeRange: TimeRange
    ) {
        heroesHistory(
            heroes: $heroes
            platform: $platform
            mode: $mode
            rank: $rank
            timeRange: $timeRange
        ) {
            hero
            role
            dateUpdated
            dateScraped
            platform
            mode
            rank
            pick
            win
        }
    }
`;

const STAT_TREND_FIELDS = `
    currentDate
    priorDate
    subsets {
        platform
        mode
        rank
        topGainers { hero role delta }
        topLosers { hero role delta }
    }
`;

export const WIN_RATE_TREND = gql`
    query WinRateTrend($platform: String, $mode: String, $rank: String, $includeThirdParty: Boolean, $includeMirrorMatches: Boolean) {
        winRateTrend(platform: $platform, mode: $mode, rank: $rank, includeThirdParty: $includeThirdParty, includeMirrorMatches: $includeMirrorMatches) {
            ${STAT_TREND_FIELDS}
        }
    }
`;

export const PICK_RATE_TREND = gql`
    query PickRateTrend($platform: String, $mode: String, $rank: String, $includeThirdParty: Boolean) {
        pickRateTrend(platform: $platform, mode: $mode, rank: $rank, includeThirdParty: $includeThirdParty) {
            ${STAT_TREND_FIELDS}
        }
    }
`;

export const ROLE_META = gql`
    query RoleMeta($platform: String, $mode: String, $rank: String, $includeThirdParty: Boolean, $usePresence: Boolean) {
        roleMeta(platform: $platform, mode: $mode, rank: $rank, includeThirdParty: $includeThirdParty, usePresence: $usePresence) {
            dateUpdated
            roles {
                role
                heroes {
                    hero
                    role
                    pick
                    win
                    winUnmirrored
                    banRate
                }
            }
        }
    }
`;

export const TP_SNAPSHOT = gql`
    query TpSnapshot($rank: String, $mode: String) {
        tpSnapshot(rank: $rank, mode: $mode) {
            dateUpdated
            heroStats { hero role pick win winUnmirrored }
        }
    }
`;

export const TP_HERO_SNAPSHOT = gql`
    query TpHeroSnapshot($hero: String!) {
        tpHeroSnapshot(hero: $hero) {
            dateUpdated
            rankStats { rank win winUnmirrored pick }
        }
    }
`;

export const HERO_LIST = gql`
    query HeroList($includeThirdParty: Boolean) {
        heroList(includeThirdParty: $includeThirdParty) {
            hero
            role
        }
    }
`;

export const FAQ = gql`
    query Faq {
        faq {
            section
            ordering
            qnas {
                question
                answer
            }
        }
    }
`;

export const HERO_ABILITIES = gql`
    query HeroAbilities {
        heroAbilities {
            datePosted
            balanceVersion
            data {
                hero
                role
                teamupAbilities {
                    name
                    iconUrl
                    teamupHeroIcon
                    description
                    enhancedDescription
                }
            }
        }
    }
`;

export const ALL_VOTE_COUNTS = gql`
    query AllVoteCounts {
        allVoteCounts {
            heroKey
            totalVotes
            abilityCounts {
                abilityName
                count
            }
        }
    }
`;

export const SUBMIT_VOTE = gql`
    mutation SubmitVote(
        $voterId: String!
        $heroKey: String!
        $abilityName: String!
        $platform: VotePlatform!
        $rank: String!
    ) {
        submitVote(
            voterId: $voterId
            heroKey: $heroKey
            abilityName: $abilityName
            platform: $platform
            rank: $rank
        ) {
            success
            message
            cooldownHours
        }
    }
`;

export const HERO_HISTORY = gql`
    query HeroHistory(
        $hero: String!
        $platform: String
        $mode: String
        $rank: String
        $role: String
        $timeRange: TimeRange
    ) {
        heroHistory(
            hero: $hero
            platform: $platform
            mode: $mode
            rank: $rank
            role: $role
            timeRange: $timeRange
        ) {
            dateUpdated
            dateScraped
            platform
            mode
            rank
            role
            pick
            win
        }
    }
`;
